import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    loadingMore: false,
    data: null,
    hasMore: false,
    page: 1,
    error: null,
    _requestId: null,
};

const fetchMyGlobalFeedsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_MY_GLOBAL_FEEDS_START: {
            const { page, requestId } = action.payload || {};
            if (page > 1) {
                return { ...state, loadingMore: true, error: null, _requestId: requestId };
            }
            return { ...state, loading: true, data: null, error: null, _requestId: requestId };
        }

        case types.GET_MY_GLOBAL_FEEDS_SUCCESS: {
            const { feeds, meta, page, requestId } = action.payload;
            if (requestId !== state._requestId) return state;
            const isFirstPage = page === 1;
            return {
                ...state,
                loading: false,
                loadingMore: false,
                data: isFirstPage ? feeds : [...(state.data || []), ...feeds],
                hasMore: meta?.has_more || false,
                page: meta?.page || page,
                error: null,
            };
        }

        case types.GET_MY_GLOBAL_FEEDS_ERROR: {
            const { requestId } = action.payload || {};
            if (requestId && requestId !== state._requestId) return state;
            return { ...state, loading: false, loadingMore: false, error: action.payload?.message || action.payload };
        }

        default:
            return state;
    }
};

export default fetchMyGlobalFeedsReducer;
